// extracted by mini-css-extract-plugin
module.exports = {"modal__player":"avatar-module--modal__player--2sw5N","img":"avatar-module--img--3eGBf","sm":"avatar-module--sm--bm3sY","xs":"avatar-module--xs--1c_MF"};